<template lang="pug">
div
  promoContent(ref="promo")
  //- .home-banner.statement-web
    div(v-for="(slide, index) in slideBannerList" )
      img.d-block.w-100(v-if="getLanguage ==='zh'" :src='imgUrl+slide.cn_image_url_desktop' @click="clickAction(slide.login_required, slide.target_window, slide.cn_href, slide.promotion_banner_id)")
      img.d-block.w-100(v-else-if="getLanguage ==='my'" :src='imgUrl+slide.mys_image_url_desktop' @click="clickAction(slide.login_required, slide.target_window, slide.mys_href.promotion_banner_id)")
      img.d-block.w-100(v-else :src='imgUrl+slide.en_image_url_desktop' @click="clickAction(slide.login_required, slide.target_window, slide.en_href, slide.promotion_banner_id)")
  //- .home-banner.statement-mob
    div(v-for="(slide, index) in slideBannerList" )
      img.d-block.w-100(v-if="getLanguage ==='zh'" :src='imgUrl+slide.cn_image_url_mobile' @click="clickAction(slide.login_required, slide.target_window, slide.cn_href, slide.promotion_banner_id)")
      img.d-block.w-100(v-else-if="getLanguage ==='my'" :src='imgUrl+slide.mys_image_url_mobile' @click="clickAction(slide.login_required, slide.target_window, slide.mys_href.promotion_banner_id)")
      img.d-block.w-100(v-else :src='imgUrl+slide.en_image_url_mobile' @click="clickAction(slide.login_required, slide.target_window, slide.en_href, slide.promotion_banner_id)")
  #carouselExampleControls.carousel.slide.main-slider.statement-web(data-bs-ride="carousel" ref="carousel_desktop")
    .carousel-indicators.custom-indicators
      template(v-for="(slide, index) in slideBannerList" )
        button(v-if="index === 0" :class="{'active' : index === 0}" data-bs-target='#carouselExampleControls' :data-bs-slide-to='index' aria-current='true' :aria-label="'Slide '+index+1")
        button(v-else data-bs-target='#carouselExampleControls' :data-bs-slide-to='index' aria-current='true' :aria-label="'Slide '+(index+1)")
    .carousel-inner
      .carousel-item(:class="{'active' : index === 0}" v-for="(slide, index) in slideBannerList")
        img.d-block.w-100(v-if="getLanguage ==='zh'" :src='imgUrl+slide.cn_image_url_desktop' @click="clickAction(slide.login_required, slide.target_window, slide.cn_href, slide.promotion_banner_id)")
        img.d-block.w-100(v-else-if="getLanguage ==='my'" :src='imgUrl+slide.mys_image_url_desktop' @click="clickAction(slide.login_required, slide.target_window, slide.mys_href,slide.promotion_banner_id)")
        img.d-block.w-100(v-else :src='imgUrl+slide.en_image_url_desktop' @click="clickAction(slide.login_required, slide.target_window, slide.en_href, slide.promotion_banner_id)")     
    //- a.carousel-control-prev(href='#carouselExampleControls' role='button' data-bs-slide='prev')
    //-   span.carousel-control-prev-icon(aria-hidden='true')
    //-   span.sr-only Previous
    //- a.carousel-control-next(href='#carouselExampleControls' role='button' data-bs-slide='next')
    //-   span.carousel-control-next-icon(aria-hidden='true')
    //-   span.sr-only Next
  #carouselExampleControlsm.carousel.slide.main-slider.statement-mob(data-bs-ride="carousel" ref="carousel_mobile")
    .carousel-indicators.custom-indicators
      template(v-for="(slide, index) in slideBannerList" )
        button(v-if="index === 0" :class="{'active' : index === 0}" data-bs-target='#carouselExampleControlsm' :data-bs-slide-to='index' aria-current='true' :aria-label="'Slide '+index+1")
        button(v-else data-bs-target='#carouselExampleControlsm' :data-bs-slide-to='index' aria-current='true' :aria-label="'Slide '+(index+1)")
    .carousel-inner
      .carousel-item(:class="{'active' : index === 0}" v-for="(slide, index) in slideBannerList")
        img.d-block.w-100(v-if="getLanguage ==='zh'" :src='imgUrl+slide.cn_image_url_mobile' @click="clickAction(slide.login_required, slide.target_window, slide.cn_href, slide.promotion_banner_id)")
        img.d-block.w-100(v-else-if="getLanguage ==='my'" :src='imgUrl+slide.mys_image_url_mobile' @click="clickAction(slide.login_required, slide.target_window, slide.mys_href,slide.promotion_banner_id)")
        img.d-block.w-100(v-else :src='imgUrl+slide.en_image_url_mobile' @click="clickAction(slide.login_required, slide.target_window, slide.en_href, slide.promotion_banner_id)")     
    //- a.carousel-control-prev(href='#carouselExampleControlsm' role='button' data-bs-slide='prev')
    //-   span.carousel-control-prev-icon(aria-hidden='true')
    //-   span.sr-only Previous
    //- a.carousel-control-next(href='#carouselExampleControlsm' role='button' data-bs-slide='next')
      span.carousel-control-next-icon(aria-hidden='true')
      span.sr-only Next
</template>
<script>
import config from "@/config";
import promoContent from "@/components2/promotionTable/_promoContent.vue"
export default{
  components:{
    promoContent
  },
  data(){
    return{
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      imgUrl: config.imageUrl,
      slideBannerList:[],
      
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    getLanguageDisplay(){
      return this.$tc(`ui.language.${this.$store.getters.language}`) || this.$tc('ui.language.en')
    },
  },
  created(){
    this.getSlideBanner()
  },
  mounted(){
    setTimeout(() => {
      const carousel_desktop = new bootstrap.Carousel(
        this.$refs.carousel_desktop
      );
      carousel_desktop.next();

      const carousel_mobile = new bootstrap.Carousel(
        this.$refs.carousel_mobile
      );
      carousel_mobile.next();
    }, 2000);
  },
  // beforeUpdate(){
  //   $('.home-banner').filter('.slick-initialized').slick('unslick');
  // },
  // updated(){
  //   $('.home-banner').not('.slick-initialized').slick({
  //     dots: false,
  //     arrows: true,
  //     infinite: true,
  //     speed: 300,
  //     autoplay: true,
  //     autoplaySpeed: 5000,
  //     slidesToShow: 1,
  //     adaptiveHeight: true
  //   });
  // },
  methods:{
    getSlideBanner(){
      this.$store
        .dispatch("user/getSlideBanner")
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
            this.slideBannerList = response.data
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
    },
    clickAction(checkLogin, target, link, promo){
      if(promo){
        this.$refs.promo.showPromo(promo, 1)
        return;
      }
      if(link == 'no'){
        return;
      }
      if(checkLogin){
        if(!this.isLoggedIn){
          this.$router.push("/login").catch(error =>{})
        }else{
          if(target === "_blank"){
            setTimeout(() => {
              window.open(link, target)
            }) 
          }else{
            this.$router.push("/"+link).catch(error =>{})
          }
        }
      }
    },
  }
}
</script>